import { apiRequest } from '@/lib/apiClient';
import type { Dia, EquipaDia, Registo, SemanaDia } from '@/types';

const qs = (params: Record<string, string | undefined>) => {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) if (value) search.set(key, value);
  const s = search.toString();
  return s ? `?${s}` : '';
};

export function fetchDia(data: string, userId?: string): Promise<Dia> {
  return apiRequest<Dia>(`/api/partes/dia${qs({ data, userId })}`);
}

export function fetchEquipaDia(data: string): Promise<EquipaDia> {
  return apiRequest<EquipaDia>(`/api/partes/dia/equipa${qs({ data })}`);
}

export function fetchSemana(data: string, userId?: string): Promise<SemanaDia[]> {
  return apiRequest<SemanaDia[]>(`/api/partes/semana${qs({ data, userId })}`);
}

export interface RegistoInput {
  data: string;
  obraId: string;
  horas: number;
  observacao?: string | null;
  userId?: string;
}

export function createRegisto(input: RegistoInput): Promise<Registo> {
  return apiRequest<Registo>('/api/partes/registos', { method: 'POST', body: input });
}

export function updateRegisto(
  id: string,
  input: Pick<RegistoInput, 'obraId' | 'horas' | 'observacao'>,
): Promise<Registo> {
  return apiRequest<Registo>(`/api/partes/registos/${id}`, { method: 'PUT', body: input });
}

export function deleteRegisto(id: string): Promise<void> {
  return apiRequest<void>(`/api/partes/registos/${id}`, { method: 'DELETE' });
}

export function setObservacaoDia(
  data: string,
  observacao: string | null,
  userId?: string,
): Promise<Dia> {
  return apiRequest<Dia>('/api/partes/observacao', {
    method: 'PUT',
    body: { data, observacao, userId },
  });
}

export function toggleFecho(data: string, userId?: string, observacao?: string): Promise<Dia> {
  return apiRequest<Dia>('/api/partes/fechar', {
    method: 'POST',
    body: { data, userId, observacao },
  });
}
